/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserProjectsCardsQuery } from '../../models/get-user-projects-cards-query';
import { GetUserProjectsCardsQueryResult } from '../../models/get-user-projects-cards-query-result';

export interface ApiProjectGetUserProjectsCardsPost$Plain$Params {
      body?: GetUserProjectsCardsQuery
}

export function apiProjectGetUserProjectsCardsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectGetUserProjectsCardsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserProjectsCardsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectGetUserProjectsCardsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserProjectsCardsQueryResult>;
    })
  );
}

apiProjectGetUserProjectsCardsPost$Plain.PATH = '/api/Project/GetUserProjectsCards';
